import type { Option } from "~/lib/options";

/** An answer to a yes / no / unknown fact as the API takes it: "" is Unknown,
 *  which the API stores as null. */
export type Answer = "true" | "false" | "";

export type AnswerOption = Option<Answer>;

export const ANSWERS: readonly AnswerOption[] = [
  { value: "true", label: "Yes" },
  { value: "false", label: "No" },
  { value: "", label: "Unknown" },
];

export function answerOf(value: boolean | null): Answer {
  if (value === null) return "";
  return value ? "true" : "false";
}
